var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgThinChevron = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.65625 14.875C0.53125 14.7812 0.46875 14.6562 0.46875 14.5312C0.46875 14.4062 0.53125 14.2812 0.625 14.1875L6.28125 8.03125L0.625 1.84375C0.4375 1.65625 0.4375 1.34375 0.65625 1.15625C0.84375 0.96875 1.15625 0.96875 1.34375 1.1875L7.34375 7.6875C7.53125 7.875 7.53125 8.15625 7.34375 8.34375L1.34375 14.8438C1.15625 15.0625 0.84375 15.0625 0.65625 14.875Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgThinChevron);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/thin-chevron.f9d725d9bab688b6081b8f4c1056f49e.svg";